import { isPrerelease, isProduction } from '@pst/biz';
import dayjs from 'dayjs';

export const websiteTiming = {
  /**
   * new Date('2025-08-29 00:00:00').valueOf()
   * 开启 pc 包问卷
   */
  onlinePCLauncher: 1756396800000,
  /**
   * new Date('2025-09-26 00:00:00').valueOf()
   * 下线 pc 包转关注社区官号
   */
  offlinePCLauncher: 1758816000000,
  /**
   * new Date('2026-07-27T02:00:00Z').valueOf()
   * UTC+8 2026-07-27 10:00
   * 预购开启时间
   */
  prePurchaseStart: 1785117600000,
  /**
   * new Date('2026-07-30T01:00:00Z').valueOf()
   * UTC+8 2026-07-30 09:00
   * 游戏上线时间
   */
  gameLaunch: 1785373200000,
};

export const getNow = () => {
  const canMock = !isProduction || isPrerelease;
  if (canMock) {
    const urlTime = new URLSearchParams(window.location.search).get('time');
    return urlTime ? dayjs(/^\d+$/.test(urlTime) ? Number(urlTime) : urlTime).valueOf() : Date.now();
  }
  return Date.now();
};
